import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthAPI, setSessionToken } from "@/lib/api";
import { useAuth } from "@/lib/providers";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await AuthAPI.exchange(session_id);
        // Also persist the session_token to localStorage so it can ride along
        // as `Authorization: Bearer` on every subsequent request. This makes
        // auth resilient against cookie-blocking browser configurations.
        if (data?.session_token) setSessionToken(data.session_token);
        await refreshUser();
        window.history.replaceState(null, "", window.location.pathname);
        // Theme is dark-only (see lib/providers), so the old light/dark
        // picker step is skipped and every new user lands straight in the
        // studio.
        navigate("/studio", { replace: true });
      } catch {
        navigate("/?error=auth", { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="v-container" style={{ paddingTop: 120 }}>
      <div className="overline">Establishing session</div>
      <h1 style={{ fontSize: 36, marginTop: 12 }}>One moment, designer.</h1>
    </div>
  );
}
